module.exports = __webpack_public_path__ + "static/media/educationbanner.7ae686e2.webp";